module.exports = __webpack_public_path__ + "img/centrum-cadeaubon.9a28f8a7.jpg";